// https://fordprofile.cms.dealer.com/ford-service-center.htm
export default {
	events: {
		'ddc.link.generic': [
			{
				// Locale for this pageType only gives english for CTA
				logic: ({ eventData }) =>
					eventData.attributes.class?.includes?.('schedule-service'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'service:fordpro elite service:content:schedule service',
							onclickLinkName:
								'service:fordpro elite service:content:action'
						}
					}
				}
			},
			{
				logic: ({ eventData }) =>
					eventData.attributes.class?.includes?.('service-specials'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'service:fordpro elite service:content:service specials',
							onclickLinkName:
								'service:fordpro elite service:content:action'
						}
					}
				}
			}
		]
	}
};
